import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import PropTypes from "prop-types";

const ConfirmationDialog = ({
   successDialog,
   closeDeleteDialog,
   deleteDialogIsOpen,
   recordName,
}) => {
   return (
      <div>
         <Dialog
            open={deleteDialogIsOpen}
            onClose={closeDeleteDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
         >
            <DialogTitle id="alert-dialog-title">{recordName}</DialogTitle>
            <DialogContent>
               <DialogContentText id="alert-dialog-description">
                  Are you sure you want to delete this record
               </DialogContentText>
            </DialogContent>
            <DialogActions>
               <Button onClick={closeDeleteDialog}>Cancel</Button>
               <Button
                  variant="outlined"
                  color="error"
                  onClick={successDialog}
                  autoFocus
               >
                  Delete
               </Button>
            </DialogActions>
         </Dialog>
      </div>
   );
};

ConfirmationDialog.propTypes = {
   successDialog: PropTypes.func,
   closeDeleteDialog: PropTypes.func,
   deleteDialogIsOpen: PropTypes.bool,
   recordName: PropTypes.string,
};

export default ConfirmationDialog;
